import { z } from 'zod';

import { CountryCodeSchema } from '../../../questions/country-code/country-code';

/**
 * `PUT /auth/phone` — the number as the member typed it, beside the country
 * they picked. The api parses it (`parseMobileNumber`) and stores the E.164;
 * the client's own parse is UX only (P30 decision 6). The response is the
 * verification state, the `PATCH /auth/email` shape: the number is stored
 * whatever became of the first code, and the screen reads the live challenge
 * facts from it.
 */
export const SetPhoneSchema = z
  .object({
    country: CountryCodeSchema,
    nationalNumber: z.string().trim().min(3).max(20),
  })
  .strict();

export type SetPhoneRequest = z.infer<typeof SetPhoneSchema>;
